import { readable } from "svelte/store";
import { assertUnreachable } from "$utils/ts-helpers";
import { browser } from "$app/environment";

const TABLET_MIN_WIDTH = 640;
const DESKTOP_MIN_WIDTH = 1024;
const LARGE_TABLET_MIN_WIDTH = 768;
const LARGE_DESKTOP_MIN_WIDTH = 1280;
type Device = "mobile" | "tablet" | "large-tablet" | "desktop" | "large-desktop";

const getMatches = (query: string): boolean => {
  // Prevents SSR issues
  if (typeof window !== "undefined") {
    // If iframe is true, we check the parent window
    return window.matchMedia(query).matches;
  }
  return false;
};

//export a function that return a readable given a string media query as input and a boolean iframe
export const getMediaQuery = (device: Device) => {
  const matches = readable<boolean>(true, (set) => {
    let deviceMinWidth = 0;
    switch (device) {
      case "mobile":
        break;
      case "tablet":
        deviceMinWidth = TABLET_MIN_WIDTH;
        break;
      case "large-tablet":
        deviceMinWidth = LARGE_TABLET_MIN_WIDTH;
        break;
      case "desktop":
        deviceMinWidth = DESKTOP_MIN_WIDTH;
        break;
      case "large-desktop":
        deviceMinWidth = LARGE_DESKTOP_MIN_WIDTH;
        break;
      default:
        assertUnreachable(device);
    }

    const query = `(min-width: ${deviceMinWidth}px)`;

    if (!browser) return;
    const matchMedia = window.matchMedia(query);

    function handleChange() {
      set(getMatches(query));
    }

    // Triggered at the first client-side load and if query changes
    handleChange();

    // Listen matchMedia
    matchMedia.addEventListener("change", handleChange);

    return () => {
      matchMedia.removeEventListener("change", handleChange);
    };
  });
  //then we return the readable
  return matches;
};
